<template>
    <div>
        <component :is="getComponentName(data.type)" v-for="(data, slug) in filters" :key="slug+Math.random()" :data="data"></component>
    </div>
</template>

<script>
  export default {
    mounted() {
      this.$root.$on('field.changed', this.setFilters);
    },
    computed: {
      filters() {
        return this.$store.state.grid.meta.filters || [];
      },
    },
    methods: {
      getComponentName(type) {
        return 'Catalog' + this.ucfirst(type) + 'Filter';
      },
      ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      setFilters($field) {
        this.$store.commit('grid/addFilter', {column: $field.slug, value: $field.getValue()});
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/extensions/rubinred/catalog/assets/js/components/CatalogDynamicFilters.vue